module.exports = __webpack_public_path__ + "static/media/logoVertical.e6e1ccea.svg";